import { Directive, inject, input } from '@angular/core';

import { BillingPlanTier } from '@core/billing-types';
import type { IconToken } from '@core/user-interface-legacy';
import { IconColorDirective } from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { FeatureGuardFacade } from '../feature-guard.facade';
import type { GuardedFeature } from '../feature-guard.types';

@Directive({
  selector: '[rtFeaturePlanIconColor]',
  standalone: true,
})
export class FeaturePlanIconColorDirective {
  private readonly iconColorDir = inject(IconColorDirective, { host: true, self: true });
  private readonly guardFacade = inject(FeatureGuardFacade);

  private readonly untilDestroyed = injectUntilDestroyed();

  public readonly feature = input<GuardedFeature>(undefined!, { alias: 'rtFeaturePlanIconColor' });

  constructor() {
    const iconColorDir = this.iconColorDir;

    if (!iconColorDir) throw new Error('Must be applied with IconColorDirective');
  }

  public ngAfterViewInit() {
    this.guardFacade
      .getPlanWhereFeatureIsAvailable(this.feature())
      .pipe(this.untilDestroyed)
      .subscribe(plan => {
        this.iconColorDir.iconColor.set(this.getIconColor(plan));
      });
  }

  private getIconColor(plan: BillingPlanTier | null): IconToken {
    switch (plan) {
      case BillingPlanTier.Scale:
        return 'colorIconOptimizeDefault';
      case BillingPlanTier.Grow:
        return 'colorIconGrowDefault';
      case BillingPlanTier.Optimize:
        return 'colorIconOptimizeDefault';
      case BillingPlanTier.Lead:
        return 'colorIconOptimizeDefault';
      default:
        return 'colorIconOptimizeDefault';
    }
  }
}
